import styled from 'styled-components';

export const Container = styled.div``;

export const CabecalhoIndice = styled.div`
  margin-left: 40px;
  margin-top: 10px;
  text-align: center;
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ResumoContainer = styled.section`
  max-width: 400px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-left: 40px;
  margin-right: 20px;
  margin-top: 10px;
`;

export const TableContainer = styled.section`
  max-width: 400px;
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  margin-left: 40px;
  margin-right: 20px;

  div {
    display: flex;
    flex: 1;
    justify-content: space-between;
    align-items: center;
    height: 20px;
    width: 400px;
    margin-bottom: 20px;
    Button {
      height: 40px;
      width: 140px;
    }
  }
`;

export const Indices = styled.table``;
